<script>
	import "iv-viewer/dist/iv-viewer.css";
	import { ImageViewer } from "iv-viewer";
	import { onMount } from "svelte";
	import { fade } from "svelte/transition";

	import ToolbarButton from "../components/ToolbarButton.svelte";
	import InvertOff from "../svg/InvertOff.svelte";
	import InvertOn from "../svg/InvertOn.svelte";
	import ZoomIn from "../svg/ZoomIn.svelte";
	import ZoomOut from "../svg/ZoomOut.svelte";
	import Rotate from "../svg/Rotate.svelte";

	export let imgPath;

	let viewer = null;
	let toggleInvert = false;
	let rotation = 0;
	let showRotateSlider = false;

	const options = {
		zoomValue: 100,
		maxZoom: 500,
		snapView: true,
		refreshOnResize: true,
		zoomOnMouseWheel: true,
	};

	onMount(() => {
		const container = document.querySelector(".viewer-container");
		viewer = new ImageViewer(container, options);
		viewer.load(imgPath[0], imgPath[1]);
		viewer.refresh();
	});

	const invert = () => {
		const image = document.querySelector(".iv-image");
		toggleInvert
			? (image.style.filter = "invert(0)")
			: (image.style.filter = "invert(1)");
		toggleInvert = !toggleInvert;
	};

	const rotate = () => {
		const image = document.querySelector(".iv-image");
		image.style.transform = `rotate(${rotation}deg)`;
	};

	const zoomIn = () => {
		if (viewer._state.zoomValue + 15 <= options.maxZoom) {
			viewer.zoom(viewer._state.zoomValue + 15);
		}
	};

	const zoomOut = () => {
		if (viewer._state.zoomValue - 15 >= 100) {
			viewer.zoom(viewer._state.zoomValue - 15);
		}
	};
</script>

<style>
	.viewer-container {
		height: calc(100vh - 71px);
		margin-left: 10px;
		margin-right: 10px;
	}

	.viewer__toolbar {
		display: flex;
		flex-direction: row-reverse;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-content: stretch;
		align-items: flex-end;
		padding-top: 3px;
		padding-right: 3px;
		margin-bottom: 3px;
		border-radius: 3px;
	}

	.slider-container {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: center;
		align-content: stretch;
		align-items: center;
	}

	.slider__value {
		color: white;
		font-size: 13px;
		font-family: "Libre Baskerville", serif;
	}

	.slider {
		height: 5px;
	}

	.viewer {
		grid-area: viewer;
		background-color: var(--dark-brown);
	}
</style>

<div class="viewer">
	<div class="viewer__toolbar">
		<ToolbarButton tooltip="Zoom out" on:click={zoomOut}>
			<ZoomOut />
		</ToolbarButton>
		<ToolbarButton tooltip="Zoom in" on:click={zoomIn}>
			<ZoomIn />
		</ToolbarButton>
		<ToolbarButton tooltip="Invert colors" on:click={invert}>
			{#if !toggleInvert}
				<InvertOff />
			{:else}
				<InvertOn />
			{/if}
		</ToolbarButton>
		<ToolbarButton
			tooltip="Rotate"
			on:click={() => (showRotateSlider = !showRotateSlider)}>
			<Rotate />
		</ToolbarButton>
		{#if showRotateSlider}
			<div class="slider-container" transition:fade>
				<div class="slider__value">{rotation} deg</div>
				<div>
					<input
						type="range"
						min="-90"
						max="90"
						class="slider"
						step="1"
						name="rotate"
						bind:value={rotation}
						on:input={rotate}
						on:mouseout={() => (showRotateSlider = false)} />
				</div>
			</div>
		{/if}
	</div>

	<div class="viewer-container" />
</div>
